const musicLinksValidationIT = {
    "add": {
        "release_name": {
            "required": "Nome della pubblicazione è richiesto"
        },
        "ean": {
            "required": "EAN/UPC è richiesto"
        },
        "artist_name": {
            "required": "Nome dell'artista è richiesto"
        },
        "url_part1": {
            "required": "Parte 1 dell'Url è richiesta"
        },
        "url_part2": {
            "required": "Parte 2 dell'Url è richiesta",
            "length": "Parte 2 dell'Url non può essere più lunga di 10 caratteri",
            "duplicate": "Oops! Questo url è già associato a un altro link musicale. Per favore prova un altro url.",
            "urlAvailable": "Url è disponibile",
            "urlInvalid": "Url non è valido"
        },
        "amazonmusic_url": {
            "required": "Url di Amazon Music è richiesto",
            "invalid": "Per favore aggiungi un Url di Amazon Music valido."
        },
        "applemusic_url": {
            "required": "Url di Apple Music è richiesto",
            "invalid": "Per favore aggiungi un Url di Apple Music valido."
        },
        "beatport_url": {
            "required": "Url di Beatport è richiesto",
            "invalid": "Per favore aggiungi un Url di Beatport valido."
        },
        "deezer_url": {
            "required": "Url di Deezer è richiesto",
            "invalid": "Per favore aggiungi un Url di Deezer valido."
        },
        "junodownload_url": {
            "required": "Url di Junodownload è richiesto",
            "invalid": "Per favore aggiungi un Url di Junodownload valido."
        },
        "soundcloud_url": {
            "required": "Url di Soundcloud è richiesto",
            "invalid": "Per favore aggiungi un Url di Soundcloud valido."
        },
        "spotify_url": {
            "required": "Url di Spotify è richiesto",
            "invalid": "Per favore aggiungi un Url di Spotify valido."
        },
        "tidal_url": {
            "required": "Url di Tidal è richiesto",
            "invalid": "Per favore aggiungi un Url di Tidal valido."
        },
        "traxsource_url": {
            "required": "Url di Traxsource è richiesto",
            "invalid": "Per favore aggiungi un Url di Traxsource valido."
        },
        "youtube_url": {
            "required": "Url di Youtube è richiesto",
            "invalid": "Per favore aggiungi un Url di Youtube valido."
        },
        "anghami_url": {
            "required": "Url di Anghami è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "bandcamp_url": {
            "required": "Url di Bandcamp è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "boomplay_url": {
            "required": "Url di Boomplay è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "iheartradio_url": {
            "required": "Url di iHeartRadio è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "jiosaavn_url": {
            "required": "Url di JioSaavn è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "sevendigital_url": {
            "required": "Url di 7digital è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "other_url": {
            "invalid": "Per favore aggiungi un Url valido."
        },
        "pvTrackName": {
            "required": "Nome del brano è richiesto"
        },
        "pvArtistName": {
            "required": "Nome dell'artista è richiesto"
        }
    },
    "update": {
        "release_name": {
            "required": "Nome della pubblicazione è richiesto"
        },
        "ean": {
            "required": "EAN/UPC è richiesto"
        },
        "artist_name": {
            "required": "Nome dell'artista è richiesto"
        },
        "url_part1": {
            "required": "Parte 1 dell'Url è richiesta"
        },
        "url_part2": {
            "required": "Parte 2 dell'Url è richiesta",
            "length": "Parte 2 dell'Url non può essere più lunga di 10 caratteri",
            "duplicate": "Oops! Questo url è già associato a un altro link musicale. Per favore prova un altro url.",
            "urlAvailable": "Url è disponibile",
            "urlInvalid": "Url non è valido"
        },
        "amazonmusic_url": {
            "required": "Url di Amazon Music è richiesto",
            "invalid": "Per favore aggiungi un Url di Amazon Music valido."
        },
        "applemusic_url": {
            "required": "Url di Apple Music è richiesto",
            "invalid": "Per favore aggiungi un Url di Apple Music valido."
        },
        "beatport_url": {
            "required": "Url di Beatport è richiesto",
            "invalid": "Per favore aggiungi un Url di Beatport valido."
        },
        "deezer_url": {
            "required": "Url di Deezer è richiesto",
            "invalid": "Per favore aggiungi un Url di Deezer valido."
        },
        "junodownload_url": {
            "required": "Url di Junodownload è richiesto",
            "invalid": "Per favore aggiungi un Url di Junodownload valido."
        },
        "soundcloud_url": {
            "required": "Url di Soundcloud è richiesto",
            "invalid": "Per favore aggiungi un Url di Soundcloud valido."
        },
        "spotify_url": {
            "required": "Url di Spotify è richiesto",
            "invalid": "Per favore aggiungi un Url di Spotify valido."
        },
        "tidal_url": {
            "required": "Url di Tidal è richiesto",
            "invalid": "Per favore aggiungi un Url di Tidal valido."
        },
        "traxsource_url": {
            "required": "Url di Traxsource è richiesto",
            "invalid": "Per favore aggiungi un Url di Traxsource valido."
        },
        "youtube_url": {
            "required": "Url di Youtube è richiesto",
            "invalid": "Per favore aggiungi un Url di Youtube valido."
        },
        "anghami_url": {
            "required": "Url di Anghami è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "bandcamp_url": {
            "required": "Url di Bandcamp è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "boomplay_url": {
            "required": "Url di Boomplay è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "iheartradio_url": {
            "required": "Url di iHeartRadio è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "jiosaavn_url": {
            "required": "Url di JioSaavn è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "sevendigital_url": {
            "required": "Url di 7digital è richiesto",
            "invalid": "Per favore aggiungi un Url valido."
        },
        "other_url": {
            "invalid": "Per favore aggiungi un Url valido."
        },
        "pvTrackName": {
            "required": "Nome del brano è richiesto"
        },
        "pvArtistName": {
            "required": "Nome dell'artista è richiesto"
        }
    }
};

export default musicLinksValidationIT;